import $ from 'jquery'

$('.quicklink').click(function(event) {
  if ($(this).data('target')) {
    event.preventDefault();

    let target = "[id^=" + $(this).data('target').replace('#', '') + "]";
    let form = $(target).closest('form');
    let value = $(this).data('value');

    $('html, body').stop().animate({
      'scrollTop': form.offset().top
    }, 100, 'swing');
    $(target).val(value);
    $(form).find('input[type="submit"]').trigger("click");
  }
});
